import React, { PropsWithChildren, useMemo } from 'react';
import { useScope } from 'contexts/scopeContext';
import { ChatDialog } from './ChatDialog';
import { ChatContextProvider } from './ChatContextProvider';

// eslint-disable-next-line @typescript-eslint/ban-types
type ChatContainerProps = PropsWithChildren<{
	currentProgramMembershipId: number | null;
}>;
export const ChatContainer = ({ children, currentProgramMembershipId }: ChatContainerProps) => {
	return (
		<ChatContextProvider currentProgramMembershipId={currentProgramMembershipId}>
			<ChatDialog />
			{children}
		</ChatContextProvider>
	);
};

// eslint-disable-next-line @typescript-eslint/ban-types
type ScopeChatContainerProps = PropsWithChildren<{
	context: 'panel' | 'program-admin' | 'coordinator';
}>;
export const ScopeChatContainer = ({ children, context }: ScopeChatContainerProps) => {
	const { currentProgramMembership, applicationsData, applicationsFetched, hasProgramAdminAccess } = useScope();

	const globalDisabled = useMemo(() => {
		if (context === 'panel' && applicationsFetched && !applicationsData.length && !hasProgramAdminAccess) {
			return true;
		}
		return false;
	}, [context, applicationsData, applicationsFetched, hasProgramAdminAccess]);

	return (
		<ChatContextProvider
			currentProgramMembershipId={currentProgramMembership?.id || null}
			globalDisabled={globalDisabled}
		>
			{!globalDisabled && <ChatDialog />}
			{children}
		</ChatContextProvider>
	);
};
